import React, { Component } from "react";
import numeral from "numeral";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { isNumber } from "util";
import "./chatclasses.css";
import Skeleton from "react-loading-skeleton";
import moment from "moment";

class AdminCard extends Component {
  constructor(props) {
    super(props);
    //console.log(JSON.stringify(this.props.data));
    this.state = {};
  }

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  itemUpdateHandler = (rowNum, newVal, recKey) => {
    // console.log(
    //   "rowNum: " + rowNum + " recKey: " + recKey + " newVal: " + newVal
    // );

    let tmpData = _.cloneDeep(this.props.data);
    //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
    if (rowNum !== undefined && isNumber(rowNum)) {
      tmpData["requestedItems"][rowNum][recKey] = newVal;
      let newAmt =
        tmpData["requestedItems"][rowNum]["quantity"] *
        tmpData["requestedItems"][rowNum]["productPrice"];
      //console.log(newAmt);
      newAmt = newAmt.toFixed(2);
      //console.log(newAmt);
      tmpData["requestedItems"][rowNum]["amount"] = "" + newAmt + "";
      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
    } else {
      //console.log(recKey + " value to be set to " + newVal);
      tmpData[recKey] = newVal;
    }

    this.props.updateRecord({ path: this.props.tableName, payload: tmpData });
  };

  getEditRow = (lable, value, fieldName, index) => {
    // console.log(
    //   "getting edit row: " + lable + " " + value + " " + fieldName + " " + index
    // );
    let calcVal = 0;
    if (fieldName === "amount") {
      if (
        this.props.data.requestedItems &&
        this.props.data.requestedItems[index]
      ) {
        let itemDets = _.cloneDeep(this.props.data.requestedItems[index]);
        let qty = itemDets.quantity;
        let prc = itemDets.productPrice;
        if (qty && qty > 0 && prc && prc > 0) {
          calcVal = (qty * prc).toFixed(2);
        }
      }
    }
    return (
      <tr>
        <td>{lable}</td>
        <td>
          <input
            type="text"
            value={fieldName === "amount" ? calcVal : value}
            onChange={e => {
              this.itemUpdateHandler(index, e.target.value, fieldName);
            }}
            style={{
              width: "100%",
              marginBottom: "2px"
            }}
          />
        </td>
      </tr>
    );
  };

  getEditBucket = (product, index) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingBottom: "5px"
        }}
      >
        <LazyLoadImage
          src={
            product.photos && product.photos.length > 0
              ? product.photos[0].url
              : ""
          }
          style={{
            maxWidth: "50px",
            maxHeight: "50px",
            height: this.state[0] ? "50px" : "0px",
            width: this.state[0] ? "50px" : "0px",
            borderRadius: "50px",
            border: this.state[0] ? "1px solid gainsboro" : "0px",
            objectFit: "contain",
            margin: this.state[0] ? "5px" : "0px",
            minWidth: this.state[0] ? "50px" : null
          }}
          afterLoad={() => {
            this.setState(prevState => {
              return {
                ...prevState,
                [0]: true
              };
            });
          }}
        />
        {!this.state[0] && (
          <Skeleton
            style={{
              height: "50px",
              width: "50px",
              borderRadius: "50px",
              border: "1px solid gainsboro",
              border: "0px solid gainsboro",
              margin: "5px"
            }}
            duration={1}
          />
        )}
        <div
          style={{
            width: "100%",
            display: "flex"
          }}
        >
          <table
            className="table table-lg"
            style={{
              margin: "auto"
            }}
          >
            {this.getEditRow(
              "Name",
              product.productNameEnglish,
              "productNameEnglish",
              index
            )}
            {this.getEditRow("Unit", product.unit, "unit", index)}
            {this.getEditRow(
              "UnitPrice",
              product.productPrice,
              "productPrice",
              index
            )}
            {this.getEditRow("Qty", product.quantity, "quantity", index)}
            {this.getEditRow("Amt", product.amount, "amount", index)}
          </table>
        </div>
      </div>
    );
  };

  getImageSize = () => {
    if (this.state.magnify) {
      return {
        maxWidth: "250px",
        maxHeight: "250px",
        height: this.state[0] ? "200px" : "0px",
        width: this.state[0] ? "200px" : "0px",
        borderRadius: "0px",
        border: this.state[0] ? "1px solid gainsboro" : "0px",
        objectFit: "contain",
        margin: this.state[0] ? "5px" : "0px",
        minWidth: this.state[0] ? "250px" : null
      };
    } else {
      return {
        maxWidth: "50px",
        maxHeight: "50px",
        height: this.state[0] ? "50px" : "0px",
        width: this.state[0] ? "50px" : "0px",
        borderRadius: "50px",
        border: this.state[0] ? "1px solid gainsboro" : "0px",
        objectFit: "contain",
        margin: this.state[0] ? "5px" : "0px",
        minWidth: this.state[0] ? "50px" : null
      };
    }
  };

  getReadOnlyBucket = product => {
    return (
      <div
        style={{
          display: !this.state.magnify ? "flex" : null,
          alignItems: "center",
          paddingBottom: "0px",
          overflow: "scroll",
          textAlign: !this.state.magnify ? null : "center"
        }}
      >
        <LazyLoadImage
          src={
            product.photos && product.photos.length > 0
              ? product.photos[0].url
              : ""
          }
          style={this.getImageSize()}
          afterLoad={() => {
            this.setState(prevState => {
              return {
                ...prevState,
                [0]: true
              };
            });
          }}
        />
        {!this.state[0] && (
          <Skeleton
            style={{
              height: "50px",
              width: "50px",
              borderRadius: "50px",
              border: "1px solid gainsboro",
              border: "0px solid gainsboro",
              margin: "5px"
            }}
            duration={1}
          />
        )}
        <div
          style={{
            width: !this.state.magnify ? "100%" : "250px",
            display: "flex",
            textAlign: !this.state.magnify ? null : "left",
            margin: !this.state.magnify ? null : "auto"
          }}
        >
          <table
            className="table table-lg"
            style={{
              margin: "auto"
            }}
          >
            <tr
              style={{
                backgroundColor: product.done ? "pink" : "transparent",
                fontWeight: product.done ? "bold" : "normal",
                fontSize: product.done ? "14px" : "6px"
              }}
            >
              <td
                style={{
                  paddingLeft: "5px"
                }}
              >
                {product.done ? "PICK UP DONE" : "PENDING PICK UP"}
              </td>
              <td
                style={{
                  textAlign: "right",
                  paddingRight: "5px"
                }}
              >
                {product.done ? (
                  <icon
                    className="fa fa-check"
                    style={{
                      fontSize: "14px"
                    }}
                  />
                ) : null}
              </td>
            </tr>
            <tr
              style={{
                fontSize: "14px"
              }}
            >
              <td>{product.productNameEnglish}</td>
              <td>
                <div
                  style={{
                    textAlign: "right",
                    margin: "3px"
                  }}
                >
                  {product.quantity + " x " + product.unit}
                </div>
              </td>
            </tr>

            <tr>
              <td>Customer Price</td>
              <td>
                <div
                  style={{
                    fontSize: "12px",
                    textAlign: "right",
                    margin: "3px"
                  }}
                >
                  ${product.amount}
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>
    );
  };

  getItems = currOgBucket => {
    //console.log("here is currBucket: " + JSON.stringify(currBucket));
    let currBucket = _.cloneDeep(currOgBucket);
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket !== "" &&
      typeof currBucket === "object"
    ) {
      return currBucket.map((product, index) => {
        return (
          <div
            style={{
              border: "1px solid white",
              margin: "0px",
              fontSize: "10px"
            }}
            onClick={() => {
              let data = _.cloneDeep(this.props.data);
              if (data.status !== "DELIVERED" && data.status !== "CANCELLED") {
                data.requestedItems[index]["done"] = !data.requestedItems[
                  index
                ]["done"];

                if (data && data.key && data.key !== "") {
                  let cloudPath = this.props.path + "/" + data.key;

                  this.props.firebase.db
                    .ref("/" + cloudPath)
                    .once("value")
                    .then(snap => {
                      return snap.ref.set(data);
                    })
                    .catch(err => {
                      console.log(err);
                      alert("Update could not be compeleted. " + err);
                      return "";
                    })
                    .then(err => {});
                }
              }
            }}
          >
            {!this.state.editMode && this.getReadOnlyBucket(product)}
            {this.state.editMode && this.getEditBucket(product, index)}
            <hr style={{ margin: "5px" }} />
          </div>
        );
      });
    }
  };

  getTotal = (currBucket, ordTotal) => {
    //console.log("calcing total again: " + JSON.stringify(currBucket));
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket !== "" &&
      typeof currBucket === "object"
    ) {
      try {
        if (this.state.editMode) {
          let totAmt = currBucket.reduce((sum, item) => {
            sum = sum + parseFloat(item.amount.replace(/,/g, ""));
            return parseFloat(sum);
          }, 0);

          return numeral(totAmt).format("0,0.00");
        } else {
          if (ordTotal && ordTotal !== "") {
            return ordTotal;
          } else {
            return "0.00";
          }
        }
      } catch (err) {
        return 0;
      }
    }
  };

  getBasicRow = (label, value, fieldName) => {
    if (this.state.editMode) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "5px",
              marginRight: "5px",
              padding: "5px",
              fontSize: "12px"
            }}
          >
            <div
              style={{
                width: "50%",
                textAlign: "left"
              }}
            >
              {label}
            </div>
            <div
              style={{
                width: "50%",
                textAlign: "left"
              }}
            >
              <input
                type="text"
                value={value}
                onChange={e => {
                  this.itemUpdateHandler(undefined, e.target.value, fieldName);
                }}
                style={{
                  width: "100%",
                  marginBottom: "2px"
                }}
              />
            </div>
          </div>
          <hr
            style={{
              margin: "0px"
            }}
          />
        </div>
      );
    } else {
      return (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "5px",
              marginRight: "5px",
              padding: "5px",
              fontSize: "12px"
            }}
          >
            <div
              style={{
                width: "50%",
                textAlign: "left"
              }}
            >
              {label}
            </div>
            <div
              style={{
                width: "50%",
                textAlign: "left",
                overflow: "scroll"
              }}
            >
              {value}
            </div>
          </div>
          <hr
            style={{
              margin: "0px"
            }}
          />
        </div>
      );
    }
  };

  saveHandler = sentData => {
    let data = _.cloneDeep(this.props.data);
    if (sentData && sentData !== undefined) {
      data = sentData;
    }
    if (data && data.key && data.key !== "") {
      let cloudPath = this.props.path + "/" + data.key;
      if (
        this.props.firebase.auth &&
        this.props.firebase.auth.currentUser &&
        this.props.firebase.auth.currentUser.phoneNumber
      ) {
        data["author"] = this.props.firebase.auth.currentUser.phoneNumber;
      } else {
        //to be covered later? do we need this for super admin?
        data["author"] = "";
      }

      this.props.firebase.db
        .ref("/" + cloudPath)
        .once("value")
        .then(snap => {
          return snap.ref.set(data);
        })
        .catch(err => {
          console.log(err);
          alert("Order could not be compeleted. " + err);
          return "";
        })
        .then(err => {
          this.stateChangeHandler(false, "editMode", false);
        });

      this.props.firebase.db
        .ref("/myOrders" + "/" + data.mobile + "/" + data.key)
        .once("value")
        .then(snap => {
          return snap.ref.set(data);
        })
        .catch(err => {
          console.log(err);
          alert("Order could not be compeleted. " + err);
          return "";
        })
        .then(err => {
          this.stateChangeHandler(false, "editMode", false);
        });
    }
  };

  saveMessageHandler = () => {
    if (
      this.state.message &&
      this.state.message.msgText &&
      this.state.message.msgText.length > 0
    ) {
      let data = _.cloneDeep(this.props.data);
      if (data.messages && data.messages.length > 0) {
        data.messages.push(this.state.message);
      } else {
        data["messages"] = [];
        data.messages.push(this.state.message);
      }
      if (data && data.key && data.key !== "") {
        let cloudPath = this.props.path + "/" + data.key;
        if (
          this.props.firebase.auth &&
          this.props.firebase.auth.currentUser &&
          this.props.firebase.auth.currentUser.phoneNumber
        ) {
          data["author"] = this.props.firebase.auth.currentUser.phoneNumber;
        } else {
          //to be covered later? do we need this for super admin?
          data["author"] = "";
        }

        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            this.props.onNotifyUsers(
              "BCS App says: " + this.refs.searchText.value,
              [data.mobile],
              false
            );
            this.refs.searchText.value = "";

            return snap.ref.set(data);
          })
          .catch(err => {
            console.log(err);
            alert("Messages could not be saved. " + err);
            return "";
          })
          .then(err => {
            this.stateChangeHandler(false, "editMode", false);
          });

        this.props.firebase.db
          .ref("/myOrders" + "/" + data.mobile + "/" + data.key)
          .once("value")
          .then(snap => {
            return snap.ref.set(data);
          })
          .catch(err => {
            console.log(err);
            alert("Order could not be compeleted. " + err);
            return "";
          })
          .then(err => {
            this.stateChangeHandler(false, "editMode", false);
          });
      }
    }
  };

  getMessages = () => {
    let msgs = this.props.data.messages;

    if (msgs && msgs.length > 0) {
      return msgs.map(msg => {
        // //if (msg.author === "+6589050302") {
        //   //console.log(JSON.stringify(this.props.allSuppliers));
        //   console.log(msg.author.replace("+65", ""));
        //   console.log(
        //     this.props.allSuppliers.includes(msg.author.replace("+65", ""))
        //   );
        // //}
        const fromMe = this.props.allSuppliers.includes(
          msg.author.replace("+65", "")
        )
          ? "from-me"
          : "";

        return (
          <div className={`message ${fromMe}`}>
            <div className="username">{msg.msgTime + "  " + msg.author}</div>
            <div className="message-body">{msg.msgText}</div>
          </div>
        );
      });
    }
  };

  getCard = () => {
    //console.log("getting card ");
    let rec = this.props.data;

    if (rec && rec !== undefined) {
      return (
        <div
          style={{
            borderRadius: "10px",
            backgroundColor: "white",
            margin: "5px",
            padding: "10px",
            marginBottom: "15px",
            fontSize: "12px",
            fontWeight: "bold",
            border: "1.5px solid #ccc",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
          }}
        >
          {this.props.regular && (
            <div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                  style={{
                    color: "#333",
                    fontSize: "14px",
                    backgroundColor: "rgb(30, 101, 144)",
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    width: "50%",
                    margin: "5px",
                    textAlign: "center"
                  }}
                >
                  <div
                    onClick={() => {
                      if (this.state.editMode) {
                        let resConfirm = confirm(
                          "Please confirm if you would like to update & save this order?"
                        );

                        if (resConfirm) {
                          //send the save here
                          this.saveHandler();
                        }
                      }
                    }}
                  >
                    SAVE
                  </div>
                </div>
                <div
                  style={{
                    color: "#333",
                    fontSize: "14px",
                    backgroundColor: "rgb(30, 101, 144)",
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    width: "50%",
                    margin: "5px",
                    textAlign: "center"
                  }}
                >
                  <div
                    onClick={() => {
                      this.stateChangeHandler(
                        !this.state.editMode,
                        "editMode",
                        false
                      );
                    }}
                  >
                    {!this.state.editMode ? "EDIT" : "CLOSE"}
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                  style={{
                    color: "#333",
                    fontSize: "14px",
                    backgroundColor:
                      this.props.data.mealType === "LUNCH"
                        ? "rgb(30, 101, 144)"
                        : "rgb(186 217 243)",
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    width: "50%",
                    margin: "5px",
                    textAlign: "center"
                  }}
                >
                  <div
                    onClick={() => {
                      let newRec = _.cloneDeep(this.props.data);
                      newRec["mealType"] = "LUNCH";
                      this.saveHandler(newRec);
                    }}
                  >
                    LUNCH
                  </div>
                </div>
                <div
                  style={{
                    color: "#333",
                    fontSize: "14px",
                    backgroundColor:
                      this.props.data.mealType &&
                      this.props.data.mealType === "DINNER"
                        ? "rgb(30, 101, 144)"
                        : "rgb(186 217 243)",
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    width: "50%",
                    margin: "5px",
                    textAlign: "center"
                  }}
                >
                  <div
                    onClick={() => {
                      let newRec = _.cloneDeep(this.props.data);
                      newRec["mealType"] = "DINNER";
                      this.saveHandler(newRec);
                    }}
                  >
                    DINNER
                  </div>
                </div>
              </div>

              {!this.state.editMode && (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div
                    style={{
                      color: "#333",
                      fontSize: "14px",
                      backgroundColor: "red",
                      padding: "5px",
                      borderRadius: "5px",
                      color: "white",
                      width: "30%",
                      margin: "5px",
                      textAlign: "center"
                    }}
                  >
                    <div
                      onClick={() => {
                        let resConfirm = confirm(
                          "Please confirm if you would like mark this order as CANCELLED?"
                        );

                        if (resConfirm) {
                          let tmpData = _.cloneDeep(this.props.data);
                          //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
                          tmpData["status"] = "CANCELLED";
                          this.saveHandler(tmpData);
                        }
                      }}
                    >
                      CANCEL
                    </div>
                  </div>
                  <div
                    style={{
                      color: "#333",
                      fontSize: "14px",
                      backgroundColor: "rgb(30, 101, 144)",
                      padding: "5px",
                      borderRadius: "5px",
                      color: "white",
                      width: "30%",
                      margin: "5px",
                      textAlign: "center"
                    }}
                  >
                    <div
                      onClick={() => {
                        let tmpData = _.cloneDeep(this.props.data);
                        //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
                        tmpData["status"] = "IN PROGRESS";

                        this.saveHandler(tmpData);
                      }}
                    >
                      WORKING
                    </div>
                  </div>
                  <div
                    style={{
                      color: "#333",
                      fontSize: "14px",
                      backgroundColor: "rgb(30, 101, 144)",
                      padding: "5px",
                      borderRadius: "5px",
                      color: "white",
                      width: "30%",
                      margin: "5px",
                      textAlign: "center"
                    }}
                  >
                    <div
                      onClick={() => {
                        let resConfirm = confirm(
                          "Please confirm if you would like mark this order as DELIVERED?"
                        );

                        if (resConfirm) {
                          let tmpData = _.cloneDeep(this.props.data);
                          //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
                          tmpData["status"] = "DELIVERED";
                          this.saveHandler(tmpData);
                        }
                      }}
                    >
                      DONE
                    </div>
                  </div>
                </div>
              )}

              <hr
                style={{
                  margin: "0px"
                }}
              />
              {this.getBasicRow("Status", rec.status, "status")}
              {this.getBasicRow(
                "Order Date",
                rec.createDateTime &&
                  rec.createDateTime !== undefined &&
                  rec.createDateTime !== ""
                  ? rec.createDateTime
                  : rec.deliveryDate +
                      " " +
                      (rec.orderTime && rec.orderTime !== ""
                        ? rec.orderTime
                        : ""),
                "deliveryDate"
              )}
              {this.getBasicRow(
                "Last Update",
                rec.updateDateTime &&
                  rec.updateDateTime !== undefined &&
                  rec.updateDateTime !== ""
                  ? rec.updateDateTime
                  : "",
                "updateDateTime"
              )}

              <div
                style={{
                  padding: "1px",
                  textAlign: "right",
                  border: "1px solid gainsboro",
                  backgroundColor: "white",
                  zIndex: "-9"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    direction: "row",
                    alignItems: "center"
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      border: "0px solid black",
                      cursor: "pointer",
                      width: "200px",
                      height: "30px",
                      lineHeight: "30px",
                      textAlign: "left",
                      margin: "5px",
                      marginLeft: "15px",
                      marginRight: "15px"
                    }}
                    onClick={() => {}}
                  >
                    Del Dt
                  </div>
                  <div
                    style={{
                      borderRadius: "5px",
                      color: "#fff",
                      backgroundColor: "rgb(30, 101, 144)",
                      fontSize: "1.5em",
                      border: "0px solid black",
                      cursor: "pointer",
                      fontWeight: "bold",
                      width: "60px",
                      height: "30px",
                      lineHeight: "30px",
                      textAlign: "center",
                      margin: "5px",
                      marginLeft: "15px"
                    }}
                    onClick={() => {
                      let currTgtDate = moment(
                        rec.targetDeliveryDate,
                        "ddd DD-MM-YYYY"
                      );
                      let newDate = currTgtDate.subtract(1, "day");
                      let newRec = _.cloneDeep(this.props.data);
                      newRec["targetDeliveryDate"] = newDate
                        .format("ddd DD-MM-YYYY")
                        .toString();
                      this.saveHandler(newRec);
                    }}
                  >
                    {"<"}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      lineHeight: "45px",
                      textAlign: "center"
                    }}
                  >
                    {rec.targetDeliveryDate}
                  </div>
                  <div
                    style={{
                      borderRadius: "5px",
                      color: "#fff",
                      backgroundColor: "rgb(30, 101, 144)",
                      fontSize: "1.5em",
                      border: "0px solid black",
                      cursor: "pointer",
                      fontWeight: "bold",
                      width: "60px",
                      height: "30px",
                      lineHeight: "30px",
                      textAlign: "center",
                      margin: "5px",
                      marginRight: "15px"
                    }}
                    onClick={() => {
                      //console.log("trying delivery date move to next");
                      let currTgtDate = moment(
                        rec.targetDeliveryDate,
                        "ddd DD-MM-YYYY"
                      );
                      //console.log(currTgtDate);
                      let newDate = currTgtDate.add(1, "day");
                      //console.log(newDate.format("ddd DD-MM-YYYY").toString());
                      let newRec = _.cloneDeep(this.props.data);
                      newRec["targetDeliveryDate"] = newDate
                        .format("ddd DD-MM-YYYY")
                        .toString();

                      this.saveHandler(newRec);
                    }}
                  >
                    {">"}
                  </div>
                </div>
              </div>

              {this.getBasicRow("Name", rec.name, "name")}
              {this.getBasicRow("Phone", rec.mobile, "mobile")}
              {this.getBasicRow(
                "Order Count",
                this.props.orderCount,
                "orderCount"
              )}
              {this.getBasicRow("Address", rec.address, "address")}
              {this.getBasicRow("Other Items", rec.otherItems)}
              <div
                style={{
                  borderRadius: "5px",
                  color: "black",
                  backgroundColor: "white",
                  fontSize: "18px",
                  border: "0px solid rgb(30, 101, 144)",
                  cursor: "pointer",
                  fontWeight: "bold",
                  height: "40px",
                  lineHeight: "40px",
                  textAlign: "center",
                  margin: "5px",
                  display: "flex"
                }}
              >
                <div
                  style={{
                    width: "50%",
                    textAlign: "left"
                  }}
                >
                  <span style={{ fontSize: "10px" }}>Items: </span>{" "}
                  {rec.requestedItems && rec.requestedItems.length > 0
                    ? rec.requestedItems.length
                    : 0}{" "}
                </div>
                <div
                  style={{
                    width: "50%",
                    textAlign: "right"
                  }}
                >
                  <span style={{ fontSize: "10px", marginLeft: "10px" }}>
                    SGD:{" "}
                  </span>{" "}
                  {rec.requestedItems && rec.requestedItems.length > 0
                    ? this.getTotal(rec.requestedItems, rec.orderTotal)
                    : ""}
                </div>
              </div>
              <hr
                style={{
                  margin: "0px"
                }}
              />
              {/* <div
            style={{
              borderRadius: "5px",
              color: "black",
              backgroundColor: "white",
              border: "0px solid rgb(30, 101, 144)",
              cursor: "pointer",
              height: "40px",
              lineHeight: "40px",
              textAlign: "center",
              margin: "5px",
              display: "flex"
            }}
          >
            <div
              style={{
                width: "50%",
                textAlign: "left"
              }}
              onClick={() => {
                this.props.fetchDistance("Lembu road Singapore", rec.address);
              }}
            >
              TAP CALC DISTANCE
            </div>
            <div
              style={{
                width: "50%",
                textAlign: "right"
              }}
            ></div>
          </div>
          <hr
            style={{
              margin: "0px"
            }}
          /> */}
              <div
                style={{
                  fontSize: "12px",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
                onClick={() => {
                  this.setState(prevState => {
                    return {
                      ...prevState,
                      showMessages: !prevState.showMessages
                    };
                  });
                }}
              >
                {!this.state.showMessages && (
                  <span
                    style={{
                      marginRight: "3px"
                    }}
                  >
                    <icon
                      className={"fa fa-eye"}
                      style={{ color: "rgb(30, 101, 144)" }}
                    />{" "}
                    SHOW MESSAGES{" ["}
                    {rec.messages && rec.messages.length > 0
                      ? rec.messages.length
                      : "0"}
                    {"]"}
                  </span>
                )}
                {this.state.showMessages && (
                  <span
                    style={{
                      marginRight: "3px"
                    }}
                  >
                    <icon
                      className={"fa fa-eye-slash"}
                      style={{ color: "rgb(30, 101, 144)" }}
                    />{" "}
                    HIDE MESSAGES
                  </span>
                )}
              </div>
              {this.state.showMessages && (
                <div
                  style={{
                    minHeight: "40px",
                    padding: "5px"
                  }}
                >
                  {this.getMessages()}
                </div>
              )}
              <hr
                style={{
                  margin: "0px"
                }}
              />
              <div
                style={{
                  display: "flex",
                  direction: "row"
                }}
              >
                <div
                  style={{
                    width: "100%"
                  }}
                >
                  <textarea
                    type="text"
                    placeholder="Enter your message"
                    ref="searchText"
                    onKeyUp={e => {
                      let msgTime = moment()
                        .format("h:mma DD-MM")
                        .toLocaleString();
                      this.setState({
                        message: {
                          msgTime: msgTime,
                          author: this.props.firebase.auth.currentUser
                            .phoneNumber,
                          msgText: e.target.value
                        }
                      });
                    }}
                    style={{
                      height: "35px",
                      borderRadius: "5px",
                      width: "100%",
                      border: "0px",
                      padding: "5px",
                      margin: "5px",
                      border: "1px solid gainsboro"
                    }}
                    rows={3}
                  />
                </div>
                <div
                  onClick={this.saveMessageHandler}
                  style={{
                    width: "60px",
                    margin: "2px",
                    textAlign: "center",
                    height: "35px",
                    /* background-color: blue; */
                    lineHeight: "35px",
                    border: "1px solid white",
                    marginTop: "5px",
                    marginBottom: "5px",
                    marginLeft: "10px",
                    backgroundColor: "rgb(30, 101, 144)",
                    color: "white"
                  }}
                >
                  Send
                </div>
              </div>
              <hr
                style={{
                  margin: "0px"
                }}
              />
              <hr
                style={{
                  margin: "0px"
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "40px",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    width: "50%",
                    textAlign: "center"
                  }}
                  onClick={() => {
                    this.setState(prevState => {
                      return {
                        ...prevState,
                        magnify: !prevState.magnify
                      };
                    });
                  }}
                >
                  <span
                    style={{
                      marginRight: "3px"
                    }}
                  >
                    <icon
                      className={
                        !this.state.magnify
                          ? "fa fa-search-plus"
                          : "fa fa-search-minus"
                      }
                      style={{ color: "rgb(30, 101, 144)" }}
                    />{" "}
                    {!this.state.magnify ? "MAGNIFY" : "UN MAGNIFY"}
                  </span>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    width: "50%",
                    textAlign: "center"
                  }}
                  onClick={() => {
                    this.setState(prevState => {
                      return {
                        ...prevState,
                        showItems: !prevState.showItems
                      };
                    });
                  }}
                >
                  <span
                    style={{
                      marginRight: "3px"
                    }}
                  >
                    <icon
                      className={
                        !this.state.showItems ? "fa fa-eye" : "fa fa-eye-slash"
                      }
                      style={{ color: "rgb(30, 101, 144)" }}
                    />{" "}
                    {!this.state.showItems ? "SHOW ITEMS [" : "HIDE ITEMS ["}
                    {rec.requestedItems ? rec.requestedItems.length : ""}
                    {"]"}
                  </span>
                </div>
              </div>
              <hr
                style={{
                  margin: "0px"
                }}
              />
              <div>
                {this.state.showItems && (
                  <div>
                    {rec.requestedItems &&
                      rec.requestedItems.length > 0 &&
                      this.getItems(rec.requestedItems)}
                  </div>
                )}
              </div>
            </div>
          )}
          {this.props.compact && (
            <div>
              <hr
                style={{
                  margin: "0px"
                }}
              />

              <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                  style={{
                    color: "#333",
                    fontSize: "14px",
                    backgroundColor: "red",
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    width: "30%",
                    margin: "5px",
                    textAlign: "center"
                  }}
                >
                  <div
                    onClick={() => {
                      let resConfirm = confirm(
                        "Please confirm if you would like mark this order as CANCELLED?"
                      );

                      if (resConfirm) {
                        let tmpData = _.cloneDeep(this.props.data);
                        //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
                        tmpData["status"] = "CANCELLED";
                        this.saveHandler(tmpData);
                      }
                    }}
                  >
                    CANCEL
                  </div>
                </div>
                <div
                  style={{
                    color: "#333",
                    fontSize: "14px",
                    backgroundColor: "rgb(30, 101, 144)",
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    width: "30%",
                    margin: "5px",
                    textAlign: "center"
                  }}
                >
                  <div
                    onClick={() => {
                      let tmpData = _.cloneDeep(this.props.data);
                      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
                      tmpData["status"] = "IN PROGRESS";

                      this.saveHandler(tmpData);
                    }}
                  >
                    WORKING
                  </div>
                </div>
                <div
                  style={{
                    color: "#333",
                    fontSize: "14px",
                    backgroundColor: "rgb(30, 101, 144)",
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    width: "30%",
                    margin: "5px",
                    textAlign: "center"
                  }}
                >
                  <div
                    onClick={() => {
                      let resConfirm = confirm(
                        "Please confirm if you would like mark this order as DELIVERED?"
                      );

                      if (resConfirm) {
                        let tmpData = _.cloneDeep(this.props.data);
                        //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
                        tmpData["status"] = "DELIVERED";
                        this.saveHandler(tmpData);
                      }
                    }}
                  >
                    DONE
                  </div>
                </div>
              </div>
              {this.getBasicRow("Customer", rec.name, "name")}
              {this.getBasicRow("Phone", rec.mobile, "mobile")}
              {this.getBasicRow("Address", rec.address, "address")}
              <div
                style={{
                  borderRadius: "5px",
                  color: "black",
                  backgroundColor: "white",
                  fontSize: "18px",
                  border: "0px solid rgb(30, 101, 144)",
                  cursor: "pointer",
                  fontWeight: "bold",
                  height: "40px",
                  lineHeight: "40px",
                  textAlign: "center",
                  margin: "5px",
                  display: "flex"
                }}
              >
                <div
                  style={{
                    width: "50%",
                    textAlign: "left"
                  }}
                >
                  <span style={{ fontSize: "10px" }}>Items: </span>{" "}
                  {rec.requestedItems && rec.requestedItems.length > 0
                    ? rec.requestedItems.length
                    : 0}{" "}
                </div>
                <div
                  style={{
                    width: "50%",
                    textAlign: "right"
                  }}
                >
                  <span style={{ fontSize: "10px", marginLeft: "10px" }}>
                    SGD:{" "}
                  </span>{" "}
                  {rec.requestedItems && rec.requestedItems.length > 0
                    ? this.getTotal(rec.requestedItems, rec.orderTotal)
                    : ""}
                </div>
              </div>
            </div>
          )}
          {this.props.messageFocus && (
            <div>
              <hr
                style={{
                  margin: "0px"
                }}
              />

              {this.getBasicRow("Customer", rec.name, "name")}
              {this.getBasicRow("Phone", rec.mobile, "mobile")}
              {this.getBasicRow("Address", rec.address, "address")}
              <div
                style={{
                  borderRadius: "5px",
                  color: "black",
                  backgroundColor: "white",
                  fontSize: "18px",
                  border: "0px solid rgb(30, 101, 144)",
                  cursor: "pointer",
                  fontWeight: "bold",
                  height: "40px",
                  lineHeight: "40px",
                  textAlign: "center",
                  margin: "5px",
                  display: "flex"
                }}
              >
                <div
                  style={{
                    width: "50%",
                    textAlign: "left"
                  }}
                >
                  <span style={{ fontSize: "10px" }}>Items: </span>{" "}
                  {rec.requestedItems && rec.requestedItems.length > 0
                    ? rec.requestedItems.length
                    : 0}{" "}
                </div>
                <div
                  style={{
                    width: "50%",
                    textAlign: "right"
                  }}
                >
                  <span style={{ fontSize: "10px", marginLeft: "10px" }}>
                    SGD:{" "}
                  </span>{" "}
                  {rec.requestedItems && rec.requestedItems.length > 0
                    ? this.getTotal(rec.requestedItems, rec.orderTime)
                    : ""}
                </div>
              </div>

              <div
                style={{
                  minHeight: "40px",
                  padding: "5px"
                }}
              >
                {this.getMessages()}
              </div>

              <hr
                style={{
                  margin: "0px"
                }}
              />
              <div
                style={{
                  display: "flex",
                  direction: "row"
                }}
              >
                <div
                  style={{
                    width: "100%"
                  }}
                >
                  <textarea
                    type="text"
                    placeholder="Enter your message"
                    ref="searchText"
                    onKeyUp={e => {
                      let msgTime = moment()
                        .format("h:mm a DD-MM")
                        .toLocaleString();

                      this.setState({
                        msgTime: msgTime,
                        message: {
                          author: this.props.firebase.auth.currentUser
                            .phoneNumber,
                          msgText: e.target.value
                        }
                      });
                    }}
                    style={{
                      height: "35px",
                      borderRadius: "5px",
                      width: "100%",
                      border: "0px",
                      padding: "5px",
                      margin: "5px",
                      border: "1px solid gainsboro"
                    }}
                    rows={3}
                  />
                </div>
                <div
                  onClick={this.saveMessageHandler}
                  style={{
                    width: "60px",
                    margin: "2px",
                    textAlign: "center",
                    height: "35px",
                    /* background-color: blue; */
                    lineHeight: "35px",
                    border: "1px solid white",
                    marginTop: "5px",
                    marginBottom: "5px",
                    marginLeft: "10px",
                    backgroundColor: "rgb(30, 101, 144)",
                    color: "white"
                  }}
                >
                  Send
                </div>
              </div>
              <hr
                style={{
                  margin: "0px"
                }}
              />
            </div>
          )}
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  render() {
    if (this.props.data && this.props.data !== undefined) {
      return this.getCard(this.props.data);

      //return this.getRows(this.props.data);
    } else {
      return <div></div>;
    }
  }
}

export default AdminCard;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/AdminCard.jsx